// components/ProductGrid.js

import React, { useState } from "react";
import { ChevronRight, ChevronLeft } from "@mui/icons-material";
import HomeSectionCard from "../HomeSectionCard/HomeSectionCard"
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

const HomeSectionGrid = ({ products, title, viewAllLink }) => {

  const [currentSlide, setCurrentSlide] = useState(0);

  while (products?.length < 4 && products?.length > 0) {
    products?.push(<div key={`placeholder-${products?.length}`} className="opacity-10" />);
  }

  const CustomPrevArrowComponent = (props) => {
    const { onClick, currentSlide } = props;
    return currentSlide > 0 ? (
      <button
        className="absolute left-1 top-[42%] -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-sm border-0 text-stone-800 flex items-center justify-center"
        onClick={onClick}
      >
        <ChevronLeft fontSize="small" />
      </button>
    ) : null;
  };

  const CustomNextArrowComponent = (props) => {
    const { onClick, currentSlide, slideCount } = props;
    return currentSlide < slideCount - 4 ? (
      <button
        className="absolute right-1 top-[42%] -translate-y-1/2 z-10 w-10 h-10 bg-white rounded-full shadow-sm border-0 text-stone-800 flex items-center justify-center"
        onClick={onClick}
      >
        <ChevronRight fontSize="small" />
      </button>
    ) : null;
  };

  const settings = {
    dots: false,
    infinite: false,
    arrows: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 3,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    prevArrow: <CustomPrevArrowComponent currentSlide={currentSlide} />,
    nextArrow: (
      <CustomNextArrowComponent
        currentSlide={currentSlide}
        slideCount={products?.length || 0}
      />
    ),
    responsive: [
      {
        breakpoint: 1440,
        settings: { slidesToShow: 4, slidesToScroll: 3 },
      },
      {
        breakpoint: 1200,
        settings: { slidesToShow: 4, slidesToScroll: 3 },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3, slidesToScroll: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 480,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
      {
        breakpoint: 360,
        settings: { slidesToShow: 2, slidesToScroll: 1 },
      },
    ],
  };

  return (
    products?.length > 0 && (
      <section className="pt-8 px-3 sm:px-4 bg-white">
        <div className="max-w-7xl mx-auto bg-cream rounded-[28px] py-8 px-4 sm:px-8">
          <div className="relative mb-8 text-center">
            <h2 className="section-heading text-[28px] md:text-[32px] leading-9">
              {title}
            </h2>
            <a
              href={viewAllLink}
              className="absolute right-0 top-1/2 -translate-y-1/2 hidden sm:inline text-stone-500 hover:text-stone-800 text-[11px] tracking-[0.16em] uppercase"
            >
              View all
            </a>
          </div>
          <div className="relative">
            <div className="w-full relative overflow-hidden">
              <Slider {...settings}>
                {products?.map((product, index) => (
                  <div key={product.id}>
                    <HomeSectionCard product={product} />
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
        <style>
          {`
            .slick-slide > div {
              margin: 0 8px; /* ✅ gap between products */
            }
            .slick-list {
              margin: 0 -8px; /* ✅ remove extra space from edges */
            }
          `}
        </style>
      </section>
    )
  );
};

export default HomeSectionGrid;
